export interface ReferralProgram {
  id: string;
  name: string;
  createdAt: string;
  archivedAt: string;
  deletedAt: string;
}

export type ReferralProgramRequest = Pick<ReferralProgram, "name">;

export enum ReferralRewardTarget {
  REFERRER = "REFERRER",
  REFEREE = "REFEREE",
}

export enum ReferralRewardType {
  RECURRING = "RECURRING",
  MILESTONE = "MILESTONE",
}

export interface ReferralReward {
  id: string;
  referralProgramId: string;
  target: ReferralRewardTarget;
  couponId: string;
  planId: string;
  type: ReferralRewardType;
  autoRedeem: boolean;
  referralsCount: number;
  maxRedemptionsPerMember: number | null;
  createdAt: string;
  deletedAt: string;
}

export interface Plan {
  id: string;
  name: string;
  isDefault: boolean;
  isRafDefault: boolean;
}

type RequiredReferralRewardFields = Pick<
  ReferralReward,
  "target" | "couponId" | "type" | "autoRedeem" | "referralsCount"
  >;
type OptionalReferralRewardFields = Partial<
  Pick<ReferralReward, "planId" | "maxRedemptionsPerMember">
  >;

export type ReferralRewardRequest = RequiredReferralRewardFields &
  OptionalReferralRewardFields;

export interface Referral {
  id: string;
  referrerId: string;
  refereeId: string;
  createdAt: string;
  stripeSubscriptionId: string;
}

export interface RewardProgress {
    programId: string;
    rewardId: string;
    type: ReferralRewardType;
    existingReferralsCount: number;
    requiredReferralsCount: number;
    maxRedemptionsPerMember: number;
}

export interface MemberReferrals {
  pendingReferrals: number;
  successfulReferrals: Referral[];
  rewardProgress: RewardProgress[];
}

export interface RewardInstance {
  id: string;
  memberId: string;
  referralProgramId: string;
  referralRewardId: string;
  createdAt: string;
  redeemedAt: string | null;
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/referrals/referrals.interfaces.ts